// import { lazy } from 'react';

// // project imports
// import Loadable from 'ui-component/Loadable';

// // login option 3 routing
// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));

// // ==============================|| AUTHENTICATION ROUTING ||============================== //

// const AuthenticationRoutes = {
//     path: '/',
//     element: <AuthLogin3 />,

// };

// export default AuthenticationRoutes;

import { lazy } from 'react';
import { Navigate } from 'react-router-dom'; // ← don't forget this import
import Loadable from 'ui-component/Loadable';
import ForgotPassword from 'views/pages/authentication/auth-forms/ForgotPassword';
import ResetPassword from 'views/pages/authentication/auth-forms/ResetPassword';

// Auth pages
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Navigate to="/auth/login" replace />
    },
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: <AuthLogin3 />
        },
        {
          path: 'register',
          element: <AuthRegister3 />
        },
        {
          path: "forgot-password",
          element: <ForgotPassword />,
        },
         {
          path: "reset-password",
          element: <ResetPassword />,
        },
      ]
    }
  ]
};

export default AuthenticationRoutes;

